import { cognitoRegion, projectRegion, userPoolsId, userPoolsWebClientId } from "./config/const";

const awsCongito = {
    "aws_project_region": projectRegion,
    // "aws_cognito_identity_pool_id": "eu-west-2:b69bf9d6-4cc0-4f1c-8af8-9fff7d4ffe27",
    "aws_cognito_region": cognitoRegion,
    "aws_user_pools_id": userPoolsId,
    "aws_user_pools_web_client_id": userPoolsWebClientId,
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "ON",
    "aws_cognito_mfa_types": [
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 12,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "mandatorySignIn": "true",

    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
};

export default awsCongito;